import { jsx as r } from "react/jsx-runtime";
const C = ({
  size: o = 24,
  color: t = "currentColor",
  strokeWidth: n = 1.5,
  ...e
}) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: o,
    height: o,
    viewBox: "0 0 24 24",
    fill: "none",
    ...e,
    children: /* @__PURE__ */ r(
      "path",
      {
        d: "M17.7 9.88849L13.7 5.88849M2.19995 21.3885L5.58432 21.0124C5.99781 20.9665 6.20455 20.9435 6.3978 20.881C6.56924 20.8255 6.7324 20.7471 6.88284 20.6479C7.05241 20.536 7.1995 20.3889 7.49368 20.0948L20.7 6.88849C21.8045 5.78392 21.8045 3.99306 20.7 2.88849C19.5954 1.78392 17.8045 1.78392 16.7 2.88848L3.49368 16.0948C3.1995 16.3889 3.05241 16.536 2.94059 16.7056C2.84138 16.856 2.76297 17.0192 2.70746 17.1906C2.64491 17.3839 2.62194 17.5906 2.57599 18.0041L2.19995 21.3885Z",
        stroke: t,
        strokeWidth: n,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
);
export {
  C as EditIcon
};
